enum BillingClaimInvoiceStatus {
    NoNote = 0,
    NoPaymentRequest,
    PaymentRequest
}

export { BillingClaimInvoiceStatus };
